import Api from "./baseApi";

export default {
    getOrderReports: order =>
        Api.get(
            `/api/reports/GetOrderReports?startDate=${order.startDate}&endDate=${
                order.endDate
            }`
        ),
    getHasAverage: order =>
        Api.get(
            `/api/reports/GetHasAverage?startDate=${order.startDate}&endDate=${
                order.endDate
            }`
        ),
    getBestSellingProductsReports: order => {
        let url = `/api/reports/getBestSellingProductsReports?startDate=${
            order.startDate
        }&endDate=${order.endDate}`;
        if (order.categoryId > -1) {
            url += `&categoryId=${order.categoryId}`;
        }
        if (order.stateId > -1) {
            url += `&state=${order.stateId}`;
        }
        return Api.get(url);
    }
    ,
    getBestSellingCategoriesReports: order =>{
        let url = `/api/reports/getBestSellingCategoryReports?startDate=${
            order.startDate
        }&endDate=${order.endDate}`;
        if (order.categoryId > -1) {
            url += `&categoryId=${order.categoryId}`;
        }
        if (order.stateId > -1) {
            url += `&state=${order.stateId}`;
        }
        return Api.get(url);
    }
        
};
